(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-access-portal"] && !Shopify.designMode) return;
  try {
    (function () {
    function getCookie(name) {
      var row = document.cookie.split('; ').find(function (item) {
        return item.indexOf(name + '=') === 0;
      });
      return row ? decodeURIComponent(row.split('=')[1]) : null;
    }

    function setCookie(name, value, days) {
      var maxAge = days * 24 * 60 * 60;
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
    }

    function clearCookie(name) {
      document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax';
    }

    function initializeAccessPortal() {
      var popupEnabled = false;
      if (!popupEnabled) return;

      var portal = document.getElementById('MethodAccessPortal');
      if (!portal) return;

      var consent = document.getElementById('mp-access-consent');
      var guestButton = document.getElementById('mp-access-guest');
      var emailField = document.getElementById('mp-access-email');

      if (window.location.search.indexOf('access-reset=1') > -1) {
        clearCookie('mp_research_access');
      }

      if (getCookie('mp_research_access') === '1') return;

      portal.classList.add('is-visible');
      portal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      if (emailField) {
        window.setTimeout(function () {
          emailField.focus();
        }, 100);
      }

      if (consent && guestButton) {
        consent.addEventListener('change', function () {
          guestButton.disabled = !consent.checked;
        });

        guestButton.addEventListener('click', function () {
          if (!consent.checked) return;
          setCookie('mp_research_access', '1', 30);
          portal.classList.remove('is-visible');
          portal.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = '';
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAccessPortal);
    } else {
      initializeAccessPortal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-card-actions"] && !Shopify.designMode) return;
  try {
    (() => {
  if (document.documentElement.hasAttribute('data-mp-card-cart')) return;
  document.documentElement.setAttribute('data-mp-card-cart', '');
  const pending = new WeakSet();
  const resetTimers = new WeakMap();
  let queue = Promise.resolve();

  const updateCartCount = async (actions) => {
    const response = await fetch(actions.dataset.cartUrl + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) return;
    const cart = await response.json();
    const count = Number(cart.item_count);
    if (!Number.isFinite(count)) return;
    const label = actions.dataset.cartCountLabel.replace('__COUNT__', String(count));
    document.querySelectorAll('.header-items__cart-link > a').forEach(link => {
      let badge = link.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          link.append(badge);
        }
        badge.textContent = String(count);
      } else {
        badge?.remove();
      }
      link.setAttribute('aria-label', label);
    });
    document.querySelectorAll('.mp-drawer-cart-count').forEach(badge => {
      badge.textContent = String(count);
      badge.setAttribute('aria-label', label);
    });
  };

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.mp-card-form')) return;
    event.preventDefault();
    if (pending.has(form)) return;
    const actions = form.closest('.mp-card-actions');
    const button = form.querySelector('button[type="submit"]');
    const feedback = actions?.querySelector('.mp-card-feedback');
    if (!actions || !button || !feedback || button.disabled) return;
    const body = new FormData(form);
    const addURL = new URL(form.action);
    addURL.pathname = addURL.pathname.replace(/\/$/, '') + '.js';
    addURL.hash = '';
    const normalText = button.dataset.normalText || button.textContent;
    const normalLabel = button.dataset.normalLabel || button.getAttribute('aria-label');
    button.dataset.normalText = normalText;
    button.dataset.normalLabel = normalLabel;
    clearTimeout(resetTimers.get(form));
    pending.add(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = actions.dataset.adding;
    feedback.classList.remove('is-error');
    feedback.textContent = '';

    queue = queue.then(async () => {
      let added = false;
      try {
        const response = await fetch(addURL, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body
        });
        const result = await response.json();
        if (!response.ok) {
          const message = typeof result.description === 'string' ? result.description : actions.dataset.error;
          throw new Error(message);
        }
        added = true;
        button.textContent = actions.dataset.added;
        button.setAttribute('aria-label', actions.dataset.added + ': ' + actions.dataset.productTitle);
        feedback.textContent = actions.dataset.productTitle + ': ' + actions.dataset.added;
      } catch (error) {
        button.textContent = normalText;
        button.setAttribute('aria-label', normalLabel);
        feedback.classList.add('is-error');
        feedback.textContent = error instanceof TypeError || error instanceof SyntaxError
          ? actions.dataset.error
          : error.message || actions.dataset.error;
      }
      try {
        await updateCartCount(actions);
      } catch (_) {}
      pending.delete(form);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (added) {
        resetTimers.set(form, setTimeout(() => {
          button.textContent = normalText;
          button.setAttribute('aria-label', normalLabel);
          resetTimers.delete(form);
        }, 2800));
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
